import uuid from 'uuid/v1';

import { INTEGRATIONS_CONSTANTS } from 'constants/base';

const getAddOns = (isUpdate, addOnsForm, secondLanguage) => {
  return addOnsForm.addOns.map(item => {
    const countryCode = 'No';
    let prices = getPreparedPricesCurrency(item);
    let secondLanguageFields = {};

    if (secondLanguage) {
      secondLanguageFields = {
        [`title${countryCode}`]: item[secondLanguage].title,
        [`description${countryCode}`]: item[secondLanguage].description
      };
    } else {
      secondLanguageFields = {
        [`title${countryCode}`]: null,
        [`description${countryCode}`]: null
      };
    }

    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      title: item.title,
      description: item.description,
      photo:
        item.coverPhoto.file || item.coverPhoto.image
          ? item.coverPhoto.file || item.coverPhoto.image
          : null,
      ...secondLanguageFields,
      prices: prices
    };
  });
};

const getMandatoryFees = (isUpdate, mandatoryFeesForm, secondLanguage) => {
  return mandatoryFeesForm.mandatoryFees.map(item => {
    const countryCode = 'No';
    let prices = getPreparedPricesCurrency(item);
    let secondLanguageFields = {};

    if (secondLanguage) {
      secondLanguageFields = {
        [`title${countryCode}`]: item[secondLanguage].title,
        [`description${countryCode}`]: item[secondLanguage].description
      };
    } else {
      secondLanguageFields = {
        [`title${countryCode}`]: null,
        [`description${countryCode}`]: null
      };
    }

    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      title: item.title,
      description: item.description,
      
      ...secondLanguageFields,
      prices: prices
    };
  });
};

const getPreparedPricesCurrency = item => {
  let prices = [];

  ['USD', 'EUR', 'NOK'].map(fieldName => {
    if (item[fieldName] && item[fieldName].length) {
      if (item[fieldName] === 'undefined') item[fieldName] = '0';
      prices.push({
        participant: item.participant,
        currency: fieldName,
        value: parseFloat(item[fieldName].split(',').join(''))
      });
    }
  });

  return prices;
};

const getCurrencyValue = (prices, currency) => {
  const foundElement = prices.find(
    price => price.currency.currency === currency
  );
  if (foundElement) return foundElement.value.toString();
  return '0';
};

const getIntegrations = (isUpdate, integrationForm) => {
  return integrationForm.integrations.map(item => {
    const idObj = isUpdate && item.isCreated ? { id: parseInt(item.id) } : {};

    return {
      ...idObj,
      platform: INTEGRATIONS_CONSTANTS[item.platform] || item.platform,
      titleOnPlatform: item.titleOnPlatform
    };
  });
};

const getPricesFixedForm = data => {
  const categoriesPrices = {};

  data.prices.map(item => {
    categoriesPrices[item.participant.participant || 'Adult'] = {
      ...categoriesPrices[item.participant.participant || 'Adult'],
      [item.currency.currency]: item.value.toString()
    };
  });

  const fixedPrice = Object.keys(categoriesPrices).map(field => ({
    USD: categoriesPrices[field]['USD'] || '0',
    EUR: categoriesPrices[field]['EUR'] || '0',
    NOK: categoriesPrices[field]['NOK'] || '0'
  }));

  return fixedPrice[0];
};

const getPricesCategoryForm = data => {
  const categoriesPrices = {};

  data.prices.map(item => {
    categoriesPrices[item.participant.participant || 'Adult'] = {
      ...categoriesPrices[item.participant.participant || 'Adult'],
      [item.currency.currency]: item.value.toString()
    };
  });

  return {
    categories: Object.keys(categoriesPrices).map(field => ({
      id: uuid(),
      participant: field,
      USD: categoriesPrices[field]['USD'] || '0',
      EUR: categoriesPrices[field]['EUR'] || '0',
      NOK: categoriesPrices[field]['NOK'] || '0'
    }))
  };
};

export {
  getAddOns,
  getMandatoryFees,
  getPreparedPricesCurrency,
  getCurrencyValue,
  getIntegrations,
  getPricesFixedForm,
  getPricesCategoryForm
};
